import { createRoot } from "react-dom/client";

import { App } from "./app/app";

// If a path has two slashes at the start, it leads to an ugly error
// message because the error happens before the app's outermost
// ErrorBoundary. So we remove extra slashes.  Very niche, but we have
// generated such URLs before by accident, and handling them is easy.
const { pathname, search, hash } = window.location;
const normalizedPathname = pathname.replace(/^\/+/, "/");

if (normalizedPathname !== pathname) {
  window.history.replaceState({}, "", `${normalizedPathname}${search}${hash}`);
}

// Actually render the App in the "root" element
const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(<App />);
